import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const EksSvgIcon = ({ primary }: SvgIconProps & { primary?: boolean }) => {
  const { palette } = useTheme();

  const color = primary ? palette.primary.main : palette.action.active;

  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2912 9.85626L12.4342 11.829L14.454 13.9865H13.7003L11.8493 12.0137V13.9865H11.2343V9.85626H11.8493V11.7038L13.5677 9.85626H14.2912ZM18.9951 14.057L17.0366 12.5362V9.70726C17.0366 9.53542 16.9471 9.37549 16.7994 9.2851L13.9958 7.56766V5.38435L18.9951 8.31066V14.057ZM19.7538 7.60044L13.7496 4.08509C13.5948 3.9947 13.4009 3.99272 13.2441 4.08112C13.0884 4.16953 12.9909 4.33342 12.9909 4.51222V7.8438C12.9909 8.01564 13.0813 8.17557 13.228 8.26596L16.0317 9.9834V12.7776C16.0317 12.9296 16.103 13.0736 16.2246 13.168L19.187 15.4705C19.2775 15.541 19.386 15.5768 19.4976 15.5768C19.5719 15.5768 19.6473 15.5599 19.7166 15.5261C19.8895 15.4437 20 15.2698 20 15.0801V8.02756C20 7.85175 19.9065 7.68884 19.7538 7.60044ZM12.5347 18.959L6.00489 15.6701V8.30967L10.9871 5.37144V7.55574L8.24781 9.2702C8.1031 9.36159 8.01467 9.51952 8.01467 9.69037V14.2566C8.01467 14.4454 8.12219 14.6172 8.29403 14.7017L12.2563 16.6426C12.397 16.7121 12.5648 16.7101 12.7065 16.6396L15.8166 15.0751L17.9058 16.8154L12.5347 18.959ZM16.2085 14.1037C16.0558 13.9755 15.8357 13.9517 15.6569 14.0411L12.4754 15.6413L9.01956 13.9487V9.96254L11.7579 8.24808C11.9036 8.15669 11.992 7.99876 11.992 7.82791V4.49732C11.992 4.31852 11.8946 4.15363 11.7378 4.06523C11.579 3.97583 11.3851 3.97881 11.2323 4.07119L5.24519 7.60044C5.09346 7.68984 5 7.85175 5 8.02756V15.9741C5 16.1608 5.10551 16.3317 5.27433 16.4161L12.2824 19.9464C12.3528 19.9821 12.4312 20 12.5106 20C12.5739 20 12.6372 19.9881 12.6985 19.9642L19.0564 17.4283C19.2192 17.3627 19.3368 17.2177 19.3649 17.0449C19.392 16.873 19.3267 16.6992 19.1921 16.587L16.2085 14.1037Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
};

EksSvgIcon.muiName = "EksSvgIcon";

export default EksSvgIcon;
